<template>
  <div>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-item @click="onTemplateDownloadClick" id="popover-target-1">
      <font-awesome-icon icon="download" class="icon mr-2"/>
      {{ $t('Download Template') }}
    </b-dropdown-item>
    <b-popover target="popover-target-1" triggers="hover" placement="right">
      <template v-slot:title>{{ $t('Xlsx Template') }}</template>
      {{ $t('For upload feature to function properly, please make sure no structural alterations are made to the downloaded template.') }}
    </b-popover>
    <b-dropdown-item @click="$refs.templateInput.click()">
      <font-awesome-icon icon="upload" class="icon mr-2"/>
      {{ $t('Upload Items') }}
    </b-dropdown-item>
    <input :multiple="false" @change="onInputChange"
           accept=".xls,.xlsx" type="file" class="d-none"
           ref="templateInput"
           id="template-uploader-input"/>
  </div>
</template>

<script>
  import InventoryService from "@/modules/inventory/InventoryService";
  import {createNamespacedHelpers} from "vuex";

  const {mapActions} = createNamespacedHelpers('inventory');

  export default {
    name: "InventoryBulkUpload",
    methods: {
      ...mapActions(['getTableData']),
      async onInputChange($event) {
        const files = $event.target.files;
        if (files.length === 0) {
          return false;
        }
        const formData = new FormData();
        formData.append('file', files[0]);
        let response = await InventoryService.uploadBulkTemplate(formData);
        if (response.success) {
          this.$toast('success', this.$i18n.t('Inventory items were successfully uploaded'));
          this.getTableData();
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0], this.$i18n.t('Bulk Upload Validation'));
          } else if (response.body.errors) {
            const listItemsArr = [];
            response.body.errors.forEach(err => listItemsArr.push(this.$createElement('li', {}, err)))
            this.$errorDialog(this.$createElement('ul', {class: "mb-0"}, listItemsArr), this.$i18n.t('Validation Error'));
          }
        }
        this.$refs.templateInput.value = null;
      },
      onTemplateDownloadClick() {
        InventoryService.downloadBulkUploadTemplate()
      }
    }
  }
</script>

<style scoped>
</style>
